<template>
  <component v-if="allowed" :is="memberView" />
  <RequestStatus v-else :error="failed" @retry="checkProject" />
</template>

<script>
import axios from 'axios';
import RequestStatus from '@/components/RequestStatus.vue';
import LoginForUser from './LoginForUser.vue';
import Register from './Register.vue';

export default {
  name: 'MemberEntry',
  components: { RequestStatus, LoginForUser, Register },
  props: { memberView: { type: String, required: true } },
  data() {
    return { allowed: false, failed: false, requestId: 0 };
  },
  watch: { memberView: 'checkProject' },
  created() { this.checkProject(); },
  beforeDestroy() { this.requestId++; },
  methods: {
    async checkProject() {
      const requestId = ++this.requestId;
      this.allowed = false;
      this.failed = false;
      try {
        const { data } = await axios.get(
          this.$store.state.src + this.$store.state.subDirectory + '/Html/GetOngoingProject',
          { params: { lang: this.$cookies.get('is_site_lang') }, timeout: 15000 }
        );
        if (requestId !== this.requestId) return;
        if (!data || !Object.prototype.hasOwnProperty.call(data, 'Project')) {
          throw new Error('Invalid project response');
        }
        if (data.Project) this.allowed = true;
        else await this.$router.replace({ name: 'Home' });
      } catch (error) {
        if (requestId === this.requestId) this.failed = true;
      }
    },
  },
};
</script>
